<div class="promo-esq"
    [ngStyle]="{ 'background': 'linear-gradient(45deg, rgba(231, 76, 60, 0), rgba(231, 76, 60, 0) 50%, #'+this.companyParams.getMainColor()+' 51%, #'+this.companyParams.getMainColor()+')',
    'top': this.topValue == undefined ? '':this.topValue+'px' }"
    style="right: 0; padding-top: 4px;
padding-left: 4px;">
    <span></span>
</div>
<div class="row details">
    <div class="col-lg-5 col-md-12 col-sm-12">


        <img class="responsive profile" defaultImage="assets/images/cruises/loading-boat.gif"
            lazyLoad="https://galavail.com/upload/fleet/" alt="img alt">
        <span class="review-star-rate big">
            <div class="loading-row">
                <div class="text w-100 loading-animate"></div>
            </div>

        </span>
        <div class="h6 preload" style="color: #999"></div>
    </div>
    <div class="col-lg-7 col-md-12 col-sm-12">
        <h4 class="preload" style="margin-top: 15px; margin-bottom: 15px;">
        </h4>
        <div class="loading-row">
            <div class="text w-70 loading-animate" style="padding-bottom: 20px;"></div>
            <div class="text w-100 loading-animate" style="margin-bottom: 20px;"></div>
            <div class="text w-100 loading-animate"></div>
            <div class="text w-100 loading-animate"></div>
            <div class="text w-100 loading-animate"></div>
        </div>

    </div>
</div>

<!-- <p>cruise-information works!</p> -->
<!-- NAV SECTION -->
<div style="margin-top: 25px; display: flex;">
    <div class="loading-row" style="width: 15%;">
        <div class="text w-100 loading-animate"></div>
    </div>
    &nbsp; &nbsp;

    <div class="loading-row" style="width: 15%;">
        <div class="text w-100 loading-animate"></div>
    </div>
    &nbsp; &nbsp;
    <div class="loading-row" style="width: 15%;">
        <div class="text w-100 loading-animate"></div>
    </div>
    &nbsp; &nbsp;
    <div class="loading-row" style="width: 15%;">
        <div class="text w-100 loading-animate"></div>
    </div>
    &nbsp; &nbsp;
</div>
<!-- / NAV SECTION -->
<!-- FACILITIES SECTION -->
<div class="loading-row">
    <div class="text w-100 loading-animate" style="height: 50px;"></div>
</div>


<!-- / FACILITIES SECTION -->
<!-- GALLERY SECTION -->
<div class="loading-row">
    <div class="text w-100 loading-animate" style="height: 50px;"></div>
</div>



<!-- / GALLERY SECTION -->
<!-- ITINERARIES SECTION -->
<div class="loading-row">
    <div class="text w-100 loading-animate" style="height: 50px;"></div>
</div>



<!-- / ITINERARIES SECTION -->
<!-- INCLUDED SECTION -->
<div class="loading-row">
    <div class="text w-100 loading-animate" style="height: 50px;"></div>
</div>

<!-- / INCLUDED SECTION -->
<!-- NOT INCLUDED SECTION -->
<div class="loading-row">
    <div class="text w-100 loading-animate" style="height: 50px;"></div>
</div>

<!-- / NOT INCLUDED SECTION -->